import React, { useEffect, useState } from "react";
import axios from '../../../../axios'
import QuestionsList from "./QuestionsList";
import assets from "../../../../assets/assets";
import AllAnswerPopup from "./AllAnswerPopup";

function QuizPopup({ setOpenQuizPopup, libraryQuestions, clickedChapterName, setAllAnswerPopup }) {

    const [questionNo, setQuestionNo] = useState(0)
    const [checkedOptions, setCheckedOptions] = useState(false);
    const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
    const [isAnswered, setIsAnswered] = useState(false);




    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucessTakeQuiz">
                <img
                    src={assets.CrossIcon}
                    className="w-7 cursor-pointer"
                    style={{ position: "absolute", top: "8px", right: "1%" }}
                    alt=""
                    onClick={(e) => setOpenQuizPopup(false)}
                />
                <div className="font-semibold text-blue-900">Take Quiz | {clickedChapterName}</div>
                {libraryQuestions.length > 0 ? (
                    <div>

                        <div className="mt-3">
                            <QuestionsList
                                label={questionNo + 1}
                                question={libraryQuestions[questionNo]}
                                setCheckedOptions={setCheckedOptions}
                                checkedOptions={checkedOptions}
                                setShowCorrectAnswer={setShowCorrectAnswer}
                                showCorrectAnswer={showCorrectAnswer}
                                setIsAnswered={setIsAnswered}
                                isAnswered={isAnswered}
                                libraryQuestions={libraryQuestions}
                            />
                        </div>
                        <div className="d-flex gap-2 justify-content-end items-center py-1">
                            {questionNo >= 1 && (
                                <button
                                    className="PreviousBtnQue"
                                    onClick={(e) => {
                                        setIsAnswered(false)
                                        setQuestionNo(questionNo - 1)
                                    }}
                                >
                                    Previous
                                </button>
                            )}

                            {libraryQuestions?.length > questionNo + 1 ? (
                                <>
                                    <button
                                        className="nextBtnQue"
                                        onClick={(e) => {
                                            setQuestionNo(questionNo + 1)
                                        }}
                                    >
                                        Skip
                                    </button>
                                    <button
                                        className={`nextBtnQue ${!checkedOptions && 'opacity-50'}`}
                                        disabled={!checkedOptions}
                                        onClick={(e) => {
                                            setCheckedOptions(false)
                                            setShowCorrectAnswer(false)
                                            setIsAnswered(false)
                                            setQuestionNo(questionNo + 1)
                                        }}
                                    >
                                        Next
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="nextBtnQue"
                                    onClick={(e) => {
                                        setOpenQuizPopup(false)
                                        setAllAnswerPopup(true)
                                    }}
                                >
                                    Finish
                                </button>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="text-xl font-semibold text-red-600 w-full h-80 p-3 flex flex-col items-center justify-center">There are no quiz questions available for this chapter at the moment.
                        <div> Please continue to review the chapter content to prepare for the upcoming quiz." !!</div> </div>
                )}

            </div>
        </div>
    )
}

export default QuizPopup;
